import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickDelete } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberScopus } from "./routeType";

const { key, getPath } = getApi("members.scopus.delete");

type IExtractedRouteType = IMemberScopus["scopusDataSingleDelete"];

export type IDeleteMemberScopus = IPickDelete<IExtractedRouteType>;

const deleteMemberScopus: Fetcher<
  IDeleteMemberScopus["response"],
  IDeleteMemberScopus["variables"]
> = ({ memberId }) => {
  return axiosClient.delete(getPath({ memberId }));
};

export const useDeleteMemberScopus = createQuery({
  queryKey: [key],
  fetcher: deleteMemberScopus,
});
